import React, { FC, useEffect, useRef, useState } from 'react'

import {
  MarqueeContainer,
  MarqueeElem,
  MarqueeText,
} from '@/components/Marquee/styles'

import { MarqueeProps } from './types'

export const Marquee: FC<MarqueeProps> = ({
  children,
  offset = 100,
  speed = 5,
  play,
  autoplay,
  delay = 0.3,
  withPause,
}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const marqueeRef = useRef<HTMLDivElement>(null)
  const [marqueeWidth, setMarqueeWidth] = useState(0)
  const [isActiveAnimation, setIsActiveAnimation] = useState(false)
  const [animationDuration, setAnimationDuration] = useState(speed)
  const animationName = withPause ? 'marqueeWithDelay' : 'marquee'

  useEffect(() => {
    if (!autoplay && !play) {
      return
    }
    startAnimation()
    return () => {
      stopAnimation()
    }
  }, [play, autoplay, children])

  const startAnimation = () => {
    const containerWidth = containerRef.current?.clientWidth || 0
    const marqueeWidth = marqueeRef.current?.clientWidth || 0
    if (!marqueeRef.current || marqueeWidth - offset < containerWidth) {
      return
    }

    marqueeRef.current.style.animation = ''
    setMarqueeWidth(marqueeWidth)
    const updatedDuration = Math.round((marqueeWidth / containerWidth) * speed)
    setAnimationDuration(updatedDuration)
    setIsActiveAnimation(true)
  }

  const stopAnimation = () => {
    if (marqueeRef.current) {
      marqueeRef.current.style.animation = 'none'
    }
    setMarqueeWidth(0)
    setIsActiveAnimation(false)
  }

  return (
    <MarqueeContainer ref={containerRef}>
      <MarqueeElem
        $width={marqueeWidth}
        $offset={offset}
        $isActiveAnimation={isActiveAnimation}
        $animationDuration={animationDuration}
        $delay={delay}
        $animationName={animationName}
      >
        <MarqueeText ref={marqueeRef}>{children}</MarqueeText>
        {isActiveAnimation && <MarqueeText>{children}</MarqueeText>}
      </MarqueeElem>
    </MarqueeContainer>
  )
}
